import Joi from 'joi';
import PropTypes  from 'prop-types';

import { getAffirmativeOptions } from '../../../utils/data';

import Button from '../../themed/button';
import Form from '../../common/form';

import toastService from '../../../services/toastService';
import _ from 'lodash';

class EditPCNLItemForm extends Form {
	state: any = {
		data: { 
            pcnlItemName: '',
            hasUTMData: '',
            hasMPTData: '',
            hasLPTData: '',
            hasConcreteData: '',
         },
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	schema = {
		pcnlItemName: Joi.string().required().label('PCNL Item Name'),
        hasUTMData: Joi.string().required().label('Has UTM Data'),
        hasMPTData: Joi.string().required().label('Has MPT Data'),
        hasLPTData: Joi.string().required().label('Has LPT Data'),
        hasConcreteData: Joi.string().required().label('Has Concrete Hammer Data')
	};

    componentDidMount() {
        if (this.props.initialPCNLItem) {
            this.setState({ data: this.props.initialPCNLItem });
        }
    }

    static propTypes = {
        pcnlItemOptions: PropTypes.string,
        initialPCNLItem: PropTypes.object,
        onEdit: PropTypes.func,
        onCancelEdit: PropTypes.func,
    }

    getPCNLItemOptions = () => {
        const missingOptions = _.difference(PCNL_INSPECTION_ITEMS, this.props.pcnlItemOptions);
        return missingOptions.concat(this.props.initialPCNLItem.pcnlItemName).map((option) => ({ id: option, name: option }));
    };

	doSubmit = () => {
		this.props.onEdit(this.state.data);
		toastService.success('Updated successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderSelect({
					name: 'pcnlItemName',
					label: 'PCNL Item Name',
					placeholder: 'Select PCNL Item Name',
                    disabled: false,
                    options: this.getPCNLItemOptions()
				})}

                <div className="divider my-4"></div>

                <div className="row">
                    <div className="col">
                        {this.renderSelect({
                            name: 'hasUTMData',
                            label: 'Has UTM Data',
                            placeholder: 'Select an Option',
                            options: getAffirmativeOptions(),
                        })}
                    </div>
                    <div className="col">
                        {this.renderSelect({
                            name: 'hasMPTData',
                            label: 'Has MPT Data',
                            placeholder: 'Select an Option',
                            options: getAffirmativeOptions(),
                        })}
                    </div>
                    <div className="col">
                        {this.renderSelect({
                            name: 'hasLPTData',
                            label: 'Has LPT Data',
                            placeholder: 'Select an Option',
                            options: getAffirmativeOptions(),
                        })}
                    </div>
                    <div className="col">
                        {this.renderSelect({
                            name: 'hasConcreteData',
                            label: 'Has Concrete Data',
                            placeholder: 'Select an Option',
                            options: getAffirmativeOptions(),
                        })}
                    </div>
                </div>

				<div className="mt-4 mb-2 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Update PCNL Item')}

                    <div className="ms-4">
                        <Button 
                            label='Cancel' 
                            style={{ backgroundColor: 'red' }} 
                            onClick={this.props.onCancelEdit} 
                        />
                    </div>
				</div>
			</form>
		);
	}
}

const PCNL_INSPECTION_ITEMS =[
    'General Inspection',
    'Material Assessment',
    'Corrosion Inspection',
    'Regulatory Compliance',
    'Safety Assessment',
    'Risk Assessment',
    'Maintenance Practices',
    'Foundation Assessment',
    'Coating Inspection', 
    'Structural Stability Analysis'
]

export default EditPCNLItemForm;
